import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper from 'swiper';
// import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';


// const wrapper = document.querySelector(".js-exhibition");
// if (wrapper) {
//   const slides = gsap.utils.toArray(".js-exhibition > div");
//   const wrapperWidth = wrapper.offsetWidth;
//   console.log(window.innerWidth);
//   // 横スクロールアニメーションの設定
//   gsap.to(wrapper, {
//     x: (wrapperWidth - window.innerWidth) * -1,
//     // xPercent: -100 * (slides.length - 1), // -X軸方向に移動
//     ease: "none", // アニメーションのイージング(noneは定速)
//     scrollTrigger: {
//       trigger: wrapper, // アニメーション開始のトリガー要素
//       pin: true, // 要素を固定
//       // anticipatePin: 1,
//       scrub: 1, // スクロール量に合わせてアニメーション
//       start: 0,
//       end: `+=${wrapperWidth}`, // アニメーションが終わる位置
//     },
//   });
// }

// init Swiper:
const swiperExhibition = new Swiper('.js-exhibition', {
  // modules: [Navigation],
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
  // speed: 600,
  // autoplay: 500,
  loop: false,
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 0,
  mousewheel: {
    forceToAxis: false,
  },
  // loopAdditionalSlides: 12,
  observer: true,
  observeParents: true,
});



// init Swiper:
const swiper = new Swiper('.js-slider', {
  modules: [Navigation],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  speed: 600,
  // autoplay: 500,
  loop: true,
  loopedSlides: 7,
  slidesPerView: 1.7,
  centeredSlides: true,
  spaceBetween: 10,
  loopAdditionalSlides: 12,
  observer: true,
  observeParents: true,

});



// import Naitei2023 from './modules/Naitei2023'
// import Naitei2023single from './modules/Naitei2023single'

// document.addEventListener('DOMContentLoaded', () => {
//   if (document.querySelector('.naitei2023')) {
//     const naitei2023 = new Naitei2023()
//   }
//   if (document.querySelector('.single-naitei2023')) {
//     const naitei2023single = new Naitei2023single()
//   }
// })
